// extracted by mini-css-extract-plugin
export default {"container":"tk-z","blurb":"uk-z","links":"vk-z"};